import { jsx as _jsx } from "react/jsx-runtime";
import Button from 'react-bootstrap/Button';
import { getSubmitButtonOptions } from '@rjsf/utils';
export default function SubmitButton(props) {
    const { submitText, norender, props: submitButtonProps } = getSubmitButtonOptions(props.uiSchema);
    if (norender) {
        return null;
    }
    return (_jsx("div", { children: _jsx(Button, { variant: 'primary', type: 'submit', ...submitButtonProps, children: submitText }) }));
}
//# sourceMappingURL=SubmitButton.js.map